"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnvironment = void 0;
function isSSR(window) {
    return !window;
}
const createEnvironment = ({ experiments = {}, browserWindow, requestUrl, userId = '', editorType = '', domain = '', previewMode = false, externalBaseUrl, }) => {
    const window = browserWindow ?? globalThis.window;
    const url = requestUrl || window?.location?.href || '';
    const baseUrl = externalBaseUrl || window?.location?.origin || '';
    const shouldForce = url.toLowerCase().includes('forcereducedmotion');
    return {
        experiments: experiments,
        isExperimentOpen: (experimentName) => Boolean(experiments[experimentName]),
        reducedMotion: shouldForce || !!window?.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches,
        userId: userId,
        editorType: editorType,
        domain: domain,
        previewMode: previewMode,
        isSSR,
        externalBaseUrl: baseUrl,
    };
};
exports.createEnvironment = createEnvironment;
//# sourceMappingURL=environment.js.map